import { render } from "./nav-bar-tools.vue?vue&type=template&id=70869a3e"
import script from "./nav-bar-tools.vue?vue&type=script&lang=js"
export * from "./nav-bar-tools.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__